module.exports = __webpack_public_path__ + "img/logo.54f89898.png";